export default __webpack_public_path__ + "static/media/closed-ranking-bg.5d9cd6c3.png";